import apiService from '../apiService'
export const rfqController = configService => {
  const service = apiService(configService)
  return {
    getListRFQ: params => {
      const strSearch = encodeURIComponent(params.eventName)
      return service.post({
        url: `cms/buyer/sourcingProjects?sourcing_project_no_and_name=${strSearch}&project_status_id=${params.statusId}&created_date_form=${params.createdDateForm}&created_date_to=${params.createdDateTo}&create_by_id=${params.createById}&page=${params.page}&limit=${params.limit}`,
      })
    },
    getReasonSourcingProject: () => {
      return service.get({
        url: `cms/buyer/sourcingProjectCancelProjectReason`,
      })
    },
    getReasonNoSelectionSourcingProject: () => {
      return service.get({
        url: `cms/buyer/sourcingProjectNoSelectionReason`,
      })
    },
    // postNoSelectionReason: params => {
    //   return service.post({
    //     url: `cms/buyer/rfq/no_selection`,
    //     params,
    //   })
    // },
    createApprovalFile: params => {
      return service.post({
        url: `cms/buyer/approval/attachment_file`,
        params,
      })
    },
    postApproveWorkflow: (params, id) => {
      return service.post({
        // url: `cms/rfq/${id}/approve`, // เก่า
        url: `cms/event/${id}/approve`,
        params,
      })
    },
    postCancelRequest: (params, id) => {
      return service.post({
        // url: `cms/buyer/approval/cancel_request`, // เก่า
        url: `cms/buyer/event/${id}/approval/cancel_request`,
        params,
      })
    },
    postRejectApprove: (objSend, id) => {
      return service.post({
        // url: `cms/rfq/${rfqId}/reject-approve`, //เก่า
        url: `cms/event/${id}/reject-approve`,
        params: {
          ...objSend,
        },
      })
    },
    getApprovalFile: id => {
      return service.get({
        url: `cms/buyer/approval/${id}/attachment_file`,
      })
    },
    downloadApprovalFile: id => {
      return service.downloadFile({
        url: `cms/buyer/approval/${id}/download`,
      })
    },
    getListRFQEventSourcing: params => {
      const strSearch = encodeURIComponent(params.eventName)
      return service.get({
        url: `cms/events?event_no_and_name=${strSearch}&status_id=${params.statusId}&seal_status_id=${params.seal_status_id}&award_status_id=${params.awardId}&approval_status_id=${params.approvalStatusId}&create_by_id=${params.createById}&page=${params.page}&limit=${params.limit}&requested_unseal=${params.requested_unseal}&event_type_id=${params.event_type_id}&just_for_me=${params.just_for_me}`,
      })
    },
    getRequestUserTec: params => {
      const strSearch = encodeURIComponent(params.search)
      return service.get({
        url: `cms/buyer/rfq/${params.idRfq}/getTecContacts?search=${strSearch}&page=${params.page}`,
      })
    },
    getCreateNewRoundValidate: params => {
      return service.get({
        url: `cms/buyer/sourcingProject/${params.idProject}/createNewRoundValidate`,
      })
    },
    getApprovalHistory: rfq_id => {
      return service.get({
        url: `cms/buyer/approval-history/${rfq_id}`,
      })
    },
    getRequestUserTecTable: params => {
      return service.get({
        url: `cms/buyer/rfq/${params.idRfq}/getTecRequested`,
      })
    },
    getPredecessor: params => {
      return service.get({
        url: `cms/buyer/sourcingProjectNameList`,
      })
    },
    createRequestUnseal: params => {
      return service.postRequestTec({
        url: 'cms/buyer/rfq/requestUnseal',
        params,
      })
    },
    // Submit unseal
    submitUnseal: params => {
      return service.postUnsealTec({
        url: 'cms/buyer/rfq/unseal',
        params,
      })
    },
    putFacade: params => {
      return service.putFacade({
        url: 'cms/rfq/facade',
        params,
      })
    },
    getBuyerList: () => {
      return service.get({
        url: `cms/buyer/event/buyer`,
      })
    },
    deleteRFQ: id => {
      return service.put({
        url: `cms/buyer/rfq/${id}/delete`,
      })
    },
    deleteSourcingProject: id => {
      return service.post({
        url: `cms/buyer/sourcingProject/${id}/delete`,
      })
    },
    createSourcingProject: params => {
      return service.put({
        url: `cms/buyer/sourcingProjectFacade`,
        params,
      })
    },
    // selectionSupplier: params => {
    //   return service.put({
    //     url: `cms/buyer/select-supplier`,
    //     params,
    //   })
    // },
    putCancelProject: params => {
      return service.put({
        url: `cms/buyer/sourcingProject/CancelProject`,
        params,
      })
    },
    createProjectAndEvent: params => {
      return service.put({
        url: `cms/buyer/sourcingProjectFacade`,
        params,
      })
    },
    getSourcingProject: params => {
      const eventId = params.eventId ? params.eventId : encodeURIComponent('')
      return service.get({
        url: `cms/buyer/sourcingProject?id=${params.id}&event_id=${eventId}`,
      })
    },
    getRFQById: id => {
      return service.get({
        url: `cms/buyer/rfq/${id}`,
      })
    },
    createDraft: params => {
      return service.put({
        url: 'cms/rfq',
        params,
      })
    },
    updateDraft: params => {
      return service.put({
        url: 'cms/rfq',
        params,
      })
    },
    getApproValWorkflow: id => {
      return service.get({
        url: `cms/buyer/rfq/${id}/approval-workflow`,
      })
    },
    createEvent: params => {
      return service.put({
        url: 'cms/rfq',
        params,
      })
    },
    createEventRfq: params => {
      return service.createEvent({
        url: 'cms/rfq',
        params,
      })
    },
    updateRFQItem: params => {
      return service.put({
        url: 'cms/rfq/item',
        params,
      })
    },

    getRFQItemById: id => {
      return service.get({
        url: `cms/rfq/${id}/item`,
      })
    },

    updateRFQSupplier: params => {
      return service.put({
        url: 'cms/rfq/supplier',
        params,
      })
    },

    // getInternalFileById: id => {
    //   return service.get({
    //     url: `cms/rfq/${id}/internal`,
    //   })
    // },
    getInternalFileProject: id => {
      return service.get({
        url: `cms/buyer/sourcingProject/${id}/internal`,
      })
    },
    getSourcingprojectStatus: () => {
      return service.get({
        url: `cms/buyer/sourcingProjectStatus`,
      })
    },
    submitAward: (data, id, saving_type) => {
      const savingType = encodeURIComponent(saving_type)
      // const id = data.rfq_id
      // const objSendsBody = {
      //   note_for_approver: data.note_for_approver,
      //   file_request: data.file_request,
      // }
      return service.post({
        // url: `cms/buyer/submit-award?rfq_id=${id}&saving_type=${savingType}`, // เก่า
        url: `cms/buyer/event/${id}/submit-award?saving_type=${savingType}`,
        params: {
          ...data,
        },
      })
    },
    reSubmitAward: id => {
      return service.post({
        // url: `cms/buyer/re-submit-award?rfq_id=${id}`, // เก่า
        url: `cms/buyer/event/${id}/re-submit-award`,
      })
    },
    clearAllSelectionSelect: id => {
      return service.post({
        url: `cms/buyer/clear-selection?rfq_id=${id}`,
      })
    },
    uploadInternalFile: params => {
      return service.post({
        url: `cms/rfq/internal`,
        params,
      })
    },
    uploadFileSourcingProject: params => {
      return service.postFormData({
        url: `cms/buyer/sourcingProject/internal`,
        params,
      })
    },
    // getExternalFileById: id => {
    //   return service.get({
    //     url: `cms/rfq/${id}/external`,
    //   })
    // },
    // UploadExternalFileById: (id, params) => {
    //   return service.post({
    //     url: `cms/rfq/${id}/external`,
    //     params,
    //   })
    // },
    // uploadExternalFile: params => {
    //   return service.post({
    //     url: `cms/rfq/external`,
    //     params,
    //   })
    // },
    // uploadRFQItemFile: params => {
    //   return service.post({
    //     url: `cms/rfq/buyer-item/upload`,
    //     params,
    //   })
    // },
    getBusinessCategory: params => {
      return service.get({
        url: `cms/buyer/event/category?cate_buyer_id=${params.catBuyerId}`,
      })
    },
    getCurrency: () => {
      return service.get({
        url: `auth/buyer/currency`,
      })
    },
    getCurrencyByCompany: () => {
      return service.get({
        url: `cms/buyer/currency_by_company`,
      })
    },
    getPurchasingCompany: (
      params = {
        sort_name: 'code',
        sort_by: 'asc',
      }
    ) => {
      return service.get({
        url: `cms/buyer/purchasing-company?sort_by=${params.sort_by}&sort_name=${params.sort_name}`,
      })
    },
    getPurchasingTypes: () => {
      return service.get({
        url: `cms/buyer/purchasing-types`,
      })
    },
    getEventTypes: () => {
      return service.get({
        url: `cms/buyer/eventTypes`,
      })
    },
    getUOM: () => {
      return service.get({
        url: `cms/uoms`,
      })
    },
    getCancelReason: () => {
      return service.get({
        url: `cms/buyer/event/cancel-reason`,
      })
    },
    // downloadExternal: id => {
    //   return service.downloadFile({
    //     url: `cms/rfq/external/${id}/download`,
    //   })
    // },
    // downloadInternal: id => {
    //   return service.downloadFile({
    //     url: `cms/rfq/internal/${id}/download`,
    //   })
    // },
    downloadFileSourcingProject: id => {
      return service.downloadFile({
        url: `cms/buyer/sourcingProject/internal/${id}/download`,
      })
    },
    // downloadItem: id => {
    //   return service.downloadFile({
    //     url: `cms/rfq/buyer-item/${id}/download`,
    //   })
    // },
    downloadCompareToExcel: (id, saveType) => {
      return service.downloadFile({
        url: `cms/buyer/rfq/${id}/compare/download?saving_type=${
          saveType ? saveType : ''
        }`,
      })
    },
    validSubmit: params => {
      return service.post({
        url: `cms/buyer/rfq/valid`,
        params,
      })
    },
    // copyRfqByID: id => {
    //   return service.get({
    //     url: `/cms/rfq/${id}/copy`,
    //   })
    // },
    // copyRfqProjectByID: params => {
    //   return service.post({
    //     url: `/cms/buyer/sourcingProjectFacade/copy`,
    //     params,
    //   })
    // },
    reScheduleRFQ: ({ event_id, end_date, start_date }) => {
      return service.put({
        url: `cms/buyer/event/${event_id}/re-schedule`,
        params: { end_date, start_date },
      })
    },
    reOpenRFQ: ({ event_id, end_date }) => {
      return service.put({
        url: `cms/buyer/event/${event_id}/re-open`,
        params: { end_date },
      })
    },
    // rfqHistories: rfqID => {
    //   return service.get({
    //     url: `cms/buyer/rfq/histories/${rfqID}`,
    //   })
    // },
    projectListHistories: projectID => {
      return service.get({
        url: `cms/buyer/sourcingProjectHistory/${projectID}`,
      })
    },
    getSupplierRfq: params => {
      const strSearch = encodeURIComponent(params.search)
      return service.get({
        url: `cms/buyer/getSuppliersWithContacts?search=${strSearch}&page=${params.pagination}`,
      })
    },
    getBuyerCompare: (id, rfqSupplier) => {
      return service.get({
        url: `cms/buyer/rfq/${id}/compare?rfq_supplier=${rfqSupplier}`,
      })
    },
    // getSupplierListCompare: id => {
    //   return service.get({
    //     url: `cms/rfq/${id}/supplier`,
    //   })
    // },
    getAttachmentFile: rfq_supplier_id => {
      return service.get({
        url: `cms/buyer/rfq/supplier/${rfq_supplier_id}/supplier-file`,
      })
    },
    downloadSupplierEventFile: id => {
      return service.downloadFile({
        url: `cms/buyer/rfq/supplier-file/${id}/download`,
      })
    },

    // getTempSourcingProject: params => {
    //   return service.get({
    //     url: `cms/buyer/sourcingProjectFacade/getTemp`,
    //     params,
    //   })
    // },
    // checkFlowUpdate: rfq_id => {
    //   return service.get({
    //     url: `cms/buyer/check-flow-update/${rfq_id}`,
    //   })
    // },
  }
}
